<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  overflow: hidden;
}
.workOrder_top_content_box_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to right, #EDF6E0, #fcfefa);
  padding: 10px 15px;
  color: #97CC49;
  border-radius: 8px 8px 0 0;
}

.workOrder_top_content_box_top .workOrder_top_content_box_top_span {
  display: inline-block;
  padding: 7px 5px;
  color: #97CC49;
  background-color: #f4faec;
  border-radius: 4px;
  font-size: 12px;
}
.workOrder_top_content_box_top2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to right, #FFEAE5, #FFFCFB);
  padding: 10px 15px;
  color: #FF8165;
  border-radius: 8px 8px 0 0;
}

.workOrder_top_content_box_top2 .workOrder_top_content_box_top_span {
  display: inline-block;
  padding: 7px 5px;
  color: #FF8165;
  background-color: #FFF2EF;
  border-radius: 4px;
  font-size: 12px;
}
.workOrder_top_content_box_top3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to right, #DEEBFE, #EBF3FE);
  padding: 10px 15px;
  color:  #3B87F7;
  border-radius: 8px 8px 0 0;
}

.workOrder_top_content_box_top3 .workOrder_top_content_box_top_span {
  display: inline-block;
  padding: 7px 5px;
  color: #3B87F7;
  background-color: #EBF3FE;
  border-radius: 4px;
  font-size: 12px;
}
.workOrder_top_content_box_top4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to right, #FFEADA, #FFFCF9);
  padding: 10px 15px;
  color:  #FF8221;
  border-radius: 8px 8px 0 0;
}

.workOrder_top_content_box_top4 .workOrder_top_content_box_top_span {
  display: inline-block;
  padding: 7px 5px;
  color: #FF8221;
  background-color: #FFF2E8;
  border-radius: 4px;
  font-size: 12px;
}
.workOrder_top_content_box_top5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to right, #E7EBF2, #E7EBF2);
  padding: 10px 15px;
  color:  #6F89B0;
  border-radius: 8px 8px 0 0;
}

.workOrder_top_content_box_top5 .workOrder_top_content_box_top_span {
  display: inline-block;
  padding: 7px 5px;
  color: #6F89B0;
  background-color: #EFF2F7;
  border-radius: 4px;
  font-size: 12px;
}
.mycheckbox{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 20px 0;
}
.htmlBox{
  width: 100%;
}
.htmlBox img{
  max-width: 100%;
}
</style>
